import React, { memo, useEffect } from 'react';
import Lottie from 'lottie-react';
import { useDispatch, useSelector } from 'react-redux';
import { accessibleOnClick } from '../../../../../shared/utils/accessible-on-click';
import AiVariant3StarIcon from '../../../../../assets/json/lottieanimation/ai-variant-3-star-icon.json';
import { WelcomeScreenProps } from '../type';
import { Cross } from '../../../../../shared/svg';
import {
  setAiColumnModalVisible,
  setShowAiColumnWelcomeScreen,
} from '../../../prospect-slice';
import { RootState } from '../../../../../store/root-reducer';
import { getAiModelRequest } from '../../../extra-actions';

const WelcomeScreen: React.FC<WelcomeScreenProps> = memo(
  ({ show, setShowIntro, showIntro, handleModalClose }) => {
    const dispatch = useDispatch();
    const showAiColumnWelcomeScreen = useSelector(
      (state: RootState) => state?.prospect?.showAiColumnWelcomeScreen,
    );
    const getAiModelList = useSelector(
      (state: RootState) => state?.prospect?.aiModelList,
    );

    useEffect(() => {
      let timeout: NodeJS.Timeout;
      if (showAiColumnWelcomeScreen) {
        timeout = setTimeout(() => {
          dispatch(setShowAiColumnWelcomeScreen(false));
        }, 2000);
      }

      return () => {
        clearTimeout(timeout);
      };
    }, []);

    useEffect(() => {
      if (!getAiModelList || getAiModelList.length === 0) {
        dispatch(getAiModelRequest());
      }
    }, []);

    useEffect(() => {
      let timeout: NodeJS.Timeout;

      if (show) {
        timeout = setTimeout(() => {
          setShowIntro(false);
        }, 500);
      } else {
        timeout = setTimeout(() => {
          setShowIntro(true);
        }, 100);
      }

      return () => {
        clearTimeout(timeout);
      };
    }, [show]);

    return (
      <div className="ai-columns-drawer-animation">
        <div
          className="close-icon"
          {...accessibleOnClick(() => {
            dispatch(setAiColumnModalVisible(false));
            handleModalClose();
          })}
        >
          {!showIntro && <Cross width={16} height={16} color="#6B7280" />}
        </div>

        <div
          className={`animation-content ${
            showAiColumnWelcomeScreen ? 'is-intro' : 'is-expanded'
          }`}
        >
          <div className="ai-column-animation-container">
            <Lottie
              animationData={AiVariant3StarIcon}
              loop
              className="ai-3-star-animated-icon"
            />
            <span className="ai-column-animated-text">
              AI Prospect Enrichment
            </span>
          </div>
          {!showIntro && (
            <span
              className={`ai-column-drawer-text ${
                showAiColumnWelcomeScreen ? '' : 'do-not-animate'
              }`}
            >
              Enrich your prospect data with AI-generated insights, personalized
              messages, and more.
            </span>
          )}
        </div>
      </div>
    );
  },
);

export default WelcomeScreen;
